import { FormControl, InputLabel, makeStyles, MenuItem, Select } from '@material-ui/core';
import { FORM_DELIVERY_TYPES, deliveryTypeToLabel } from '../../constants/delivery-type.constants';
import { DeliveryType } from '../../types/delivery-selection.type';

type Props = {
  value: DeliveryType;
  onChange: (value: DeliveryType) => void;
};

const useStyles = makeStyles({
  root: {
    minWidth: 200,
  },
});

export function DeliveryTypeSelector({ value, onChange }: Props) {
  const classes = useStyles();

  return (
    <FormControl variant="outlined" size="small" className={classes.root}>
      <InputLabel>Type de livraison</InputLabel>
      <Select
        label="Type de livraison"
        value={value}
        onChange={(event) => onChange(event.target.value as DeliveryType)}
      >
        {FORM_DELIVERY_TYPES.map((type) => (
          <MenuItem key={type} value={type}>
            {deliveryTypeToLabel(type)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
